const convertKeysToSnakeCase = (obj) => Object.fromEntries(Object.entries(obj).map(([key, value]) => [
    key.replace(/[A-Z]/gu, (letter) => `_${letter.toLowerCase()}`),
    value,
]));
const serializeEvent = (event) => convertKeysToSnakeCase({
    ...event,
    date: event.date.toISOString(),
});
class EventResource {
    client;
    constructor(client) {
        this.client = client;
    }
    create(event) {
        void this.client.post("/event", serializeEvent(event));
    }
}
export { EventResource };
